export default "__VITE_ASSET__DJfcli3a__"